// extracted by mini-css-extract-plugin
export var title = "commonStyles-module--title--RonLZ";
export var text = "commonStyles-module--text--h9+f8";